export default __webpack_public_path__ + "static/media/startup-program.69ab11ce.png";